/* eslint-disable import/prefer-default-export */
import { DateTime } from 'luxon';

const shift = (hour: number, minute: number, duration: number, day: number) => {
  const start = DateTime.now().set({ hour, minute }).plus({ day });
  const end = start.plus({ minute: duration });
  return { start, end };
};

export const shifts = [{
  ...shift(9, 0, 240, 1),
  location: 'Big Box Co. North Lakes, QLD, Australia',
  type: 'Checkout',
}, {
  ...shift(9, 0, 480, 2),
  location: 'Big Box Co. North Lakes, QLD, Australia',
  type: 'Checkout',
}, {
  ...shift(12, 15, 360, 3),
  location: 'Big Box Co. Mango Hill, QLD, Australia',
  type: 'Checkout',
}, {
  ...shift(21, 0, 240, 6),
  location: 'Big Box Co. Mango Hill, QLD, Australia',
  type: 'Night Fill',
}, {
  ...shift(21, 30, 240, 7),
  location: 'Big Box Co. Mango Hill, QLD, Australia',
  type: 'Night Fill',
}, {
  ...shift(9, 0, 60 * 8, 8),
  location: 'Big Box Co. North Lakes, QLD, Australia',
  type: 'On Call',
}, {
  ...shift(9, 0, 60 * 8, 9),
  location: 'Big Box Co. Chermside, QLD, Australia',
  type: 'On Call',
}];
